import Animation from 'src/components/common/animation';
import { useMetabaseEmbed } from 'src/hooks/metabaseEmbed/useMetabaseEmbed';

export function CompanySummary() {
  const { iframeUrl } = useMetabaseEmbed();

  return (
    <>
      {iframeUrl === '' ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          <Animation
            icon="chat-loading"
            style={{
              border: '6px solid transparent',
              borderColor: 'var(--background-spinner)',
              borderTopColor: 'var(--green-polichat)',
            }}
          />
        </div>
      ) : (
        <iframe
          src={iframeUrl}
          width="100%"
          height="100%"
          allowTransparency
          title="Metabase Dashboard"
        />
      )}
    </>
  );
}